import { createFileRoute } from "@tanstack/react-router";

import MarketingLayout from "@/components/marketing/MarketingLayout";

/**
 * A sibling of `_app` for the reason `blog` is: these pages are public, and
 * `_app`'s `RouteGuard` would bounce an anonymous reader to sign-in.
 */
export const Route = createFileRoute("/blog-categories")({
  component: MarketingLayout,
});
